import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PropTypes from 'prop-types';
import './styles/AAFModalTelmexActivate.scss';

const AAFModalTelmexActivate = (props = {}) => {
    const contentAccept = Translator.get(
        'redirectTelmexmexicogate_modal_description_label',
        'Te invitamos a agregar el medio de pago Telmex/Tenor desde un navegador web, para que puedas realizar tus transacciones y disfrutar del contenido en ese dispositivo.'
    );
    const contentFail = Translator.get(
        'activateTelmexmexicogate_modal_description_label',
        'Para concluir el proceso de contratacion con Telmex/Tenor llama al 800 252 9999'
    );
    const content = props.account !== null ? contentAccept : contentFail;

    const p = {
        content,
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        buttons: [
            {
                content: Translator.get(
                    'redirectTelmexmexicogate_modal_option_button_close',
                    'Aceptar'
                ),
                props: {
                    onClick: (e) => {
                        props.handleClose(e, props.callback);
                    },
                    className: 'aaf-modal-button aaf-modal-button-primary',
                },
            },
        ],
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: true,
    };
    return <ModalWrapper {...p} />
};

AAFModalTelmexActivate.propTypes = {
    className: PropTypes.string,
};

export default withOnClose(AAFModalTelmexActivate);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalTelmexActivate.jsx